/* eslint-disable react/prop-types */
import React from 'react'
import { Menu, menuItemContainer, Typeahead } from 'react-bootstrap-typeahead'
import intl from 'react-intl-universal'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap'
import { categories } from '../../../modules/services/distributor'
import { DistributorSFCProps } from './types'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./styles.scss')

const Required = (): JSX.Element => (
  <span className="text-danger label-required">required</span>
)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MenuItem = menuItemContainer(({ active, ...restProps }) => (
  <li {...restProps} />
))

export const DistributorSFC: React.FunctionComponent<DistributorSFCProps> = (
  props
): JSX.Element => {
  return (
    <div className={`bootstrap4 ${styles.distributor}`}>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label
              for="distributor"
              className={props.distributorRequired ? 'text-danger' : ''}
            >
              {intl.get('MetaTemplates.distributor.label')}
              {props.isRequired && <span className="text-danger"> ✱</span>}
            </Label>
            <div data-testid="editor-distributor-input">
              <Typeahead
                id="distributor-typeahead"
                type="select"
                inputProps={{ id: 'distributor' }}
                className={props.distributorRequired ? 'required' : ''}
                placeholder={intl.get(
                  'MetaTemplates.distributor.template.distributorPlaceholder'
                )}
                highlightOnlyResult={true}
                selected={props.typeaheadSelected}
                onChange={(selected) => props.setDistributor(selected)}
                onInputChange={props.isTyping}
                onBlur={props.typeaheadOnBlur}
                labelKey="name"
                options={props.distributorOptions}
                filterBy={props.initFocused ? () => true : undefined}
                renderMenu={(results, menuProps) => (
                  <Menu {...menuProps}>
                    {results.map((result, index) => (
                      <MenuItem key={index} option={result} position={index}>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a className="dropdown-item">{result.name}</a>
                      </MenuItem>
                    ))}
                  </Menu>
                )}
              />
            </div>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            {props.nameRequired && <Required />}
            <Label
              for="distributor-name"
              className={props.nameRequired ? 'text-danger' : ''}
            >
              {intl.get('MetaTemplates.distributor.template.name')}
              {props.isCustom && <span className="text-danger"> ✱</span>}
            </Label>
            <Input
              type="text"
              id="distributor-name"
              className={props.nameRequired ? 'required' : ''}
              value={props.name}
              onChange={(event) =>
                props.updateCustomDistributor('name', event.target.value)
              }
              readOnly={!props.isCustom}
              placeholder={
                props.isCustom
                  ? intl.get(
                      'MetaTemplates.distributor.template.namePlaceholder'
                    )
                  : ''
              }
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            {props.categoryRequired && <Required />}
            <Label
              for="distributor-category"
              className={props.categoryRequired ? 'text-danger' : ''}
            >
              {intl.get('MetaTemplates.distributor.template.category')}
              {props.isCustom && <span className="text-danger"> ✱</span>}
            </Label>
            {props.isCustom ? (
              <Input
                type="select"
                id="distributor-category"
                className={props.categoryRequired ? 'required' : ''}
                value={props.category}
                onChange={(event) =>
                  props.updateCustomDistributor('category', event.target.value)
                }
              >
                <option
                  value=""
                  disabled={true}
                  aria-selected={props.category === ''}
                >
                  {intl.get(
                    'MetaTemplates.distributor.template.categoryPlaceholder'
                  )}
                </option>
                {categories.map((category) => {
                  return (
                    <option
                      value={category}
                      key={category}
                      aria-selected={props.category === ''}
                    >
                      {intl.get(`Distributor.categories.${category}`)}
                    </option>
                  )
                })}
              </Input>
            ) : (
              <Input
                id="distributor-category"
                className={props.categoryRequired ? 'required' : ''}
                value={props.category}
                readOnly={true}
              />
            )}
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="distributor-subcategory">
              {intl.get('MetaTemplates.distributor.template.subcategory')}
            </Label>
            <Input
              type="text"
              id="distributor-subcategory"
              value={props.subcategory}
              onChange={(event) =>
                props.updateCustomDistributor('subcategory', event.target.value)
              }
              readOnly={!props.isCustom}
              placeholder={
                props.isCustom
                  ? intl.get(
                      'MetaTemplates.distributor.template.subcategoryPlaceholder'
                    )
                  : ''
              }
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  )
}
